import React, { useState, useEffect, useRef } from 'react';
import {Col, Divider, Layout, Menu, Popover, Row, Tooltip} from 'antd';
import ab_ai_icon from '../../assets/ab_ai_icon.svg';
import ai_prep_bigger from '../../assets/ai_prep_bigger.svg';
import ai_prep_message from '../../assets/ai_prep_message.svg';
import style from './ChatPreset.module.css';
import {cookies} from "../../api/axiosinstance.js";
import {logoutEv} from "../../models/authModel/index.js";
import TableChat from "../../components/TableChat.jsx";
import QuestionCircleOutlined from '@ant-design/icons/QuestionCircleOutlined.js'
import FileDoneOutlined from '@ant-design/icons/FileDoneOutlined.js'
import CloseOutlined from '@ant-design/icons/CloseOutlined.js'
import HistoryOutlined from '@ant-design/icons/HistoryOutlined.js'
import FileAddOutlined from '@ant-design/icons/FileAddOutlined.js'
import FaqModal from "../../components/Faq.jsx";
import {Header} from "antd/es/layout/layout.js";
import Button from "antd/es/button";
import Sider from "antd/es/layout/Sider.js";
import dayjs from "dayjs";


const google_service_dict = {
  DOCX: 'Google Документ',
  Excel: 'Google Таблицы',
};


const styles = {
  chatContainer: {
    width: '100%',
    border: '1px solid #ccc',
    borderRadius: '8px',
    overflow: 'hidden',
    fontFamily: 'Arial, sans-serif',
    // height: '100%',
    height: '98vh'
  },
  messagesContainer: {
    background: 'linear-gradient(118.17deg, #EDF7EE 0%, #CEFFD3 100%)',
    overflowY: 'auto',
    padding: '10px',
    backgroundColor: '#f9f9f9',
    height: 'calc(100% - 130px)',
    width: '95vw'
  },
  message: {
    marginBottom: '10px',
    padding: '8px 12px',
    maxWidth: '80%',
  },
  userMessage: {
    background: '#F8FFF8',
    alignSelf: 'flex-end',
    textAlign: 'right',
    marginLeft: 'auto',
    color: '#1B1C1D',
    borderRadius: '24px 0px 24px 24px',
  },
  apiMessage: {
    backgroundColor: '#FFF',
    color: '#1B1C1D',
    textAlign: 'left',
    borderRadius: '0px 24px 24px 24px',
  },
  typingIndicator: {
    backgroundColor: '#FFF',
    color: '#1B1C1D',
    textAlign: 'left',
    borderRadius: '0px 24px 24px 24px',
    marginBottom: '10px',
    padding: '8px 12px',
    maxWidth: '80%',
    fontStyle: 'italic',
    fontSize: '16px',
    lineHeight: '28px',
  },
  messageText: {
    margin: 0,
    fontSize: '16px',
    lineHeight: '28px',
    fontFamily: 'Inter',
  },
  inputContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '14px',
    // padding: '19px 20px 20px 20px',
    borderTop: '1px solid #ddd',
    backgroundColor: '#fff',
    position: 'relative',
  },
  input: {
    flex: 1,
    padding: '10px',
    borderRadius: '6px',
    border: '1px solid #ddd',
    fontSize: '14px',
    outline: 'none',
    marginRight: '10px',
  },
  sendButton: {
    padding: '11px 20px',
    border: 'none',
    borderRadius: '6px',
    backgroundColor: '#30A93E',
    color: '#fff',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
  },
  sendButtonHover: {
    backgroundColor: '#0056b3',
  },
  apiMessage_wrapper: {
    display: 'flex',
    columnGap: 15,
    // border: '1px solid red'
  },
  api_avatar: {
    width: 50,
    height: 50,
    borderRadius: '100%',
    background: 'white',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  preparedMessages_wrapper: {
    position: 'absolute',
    bottom: '80px',
    width: '100%',
    overflowX: 'scroll',
    paddingBottom: '5px'
  },
  preparedMessage: {
    background: '#F8FFF8',
    borderRadius: '12px',
    fontSize: '14px',
    lineHeight: '21px',
    fontFamily: 'Inter',
    color: '#1B1C1D',
    padding: '15px 10px 10px 10px',
    position: 'relative',
    width: 185,
    marginTop: 15,
    cursor: 'pointer',
    marginRight: '10px',
  },
  preparedMessage_badge: {
    position: 'absolute',
    left: '50%',
    top: '-15px',
    transform: 'translateX(-50%)',
    background: '#87C960',
    borderRadius: '100%',
    width: 30,
    height: 30,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  preparedMessage_popover_button: {
    position: 'absolute',
    top: '-60px',
    right: '25px',
    background: '#30A93E',
    borderRadius: '100%',
    width: '50px',
    height: '50px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  preparedMessage_popover: {
    background: '#F8FFF8',
    padding: 15,
  },

  scrollArea: {
    scrollbarWidth: 'thin', // Firefox
    scrollbarColor: '#a777e3 #f0f0f0', // Firefox
  },

  preparedMessage_popover_help: {
    position: 'absolute',
    top: '24px',
    right: '55px',
    background: '#30A93E',
    borderRadius: '100%',
    width: '50px',
    height: '50px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  preparedMessage_popover_faq: {
    position: 'absolute',
    top: '86px',
    right: '55px',
    background: '#30A93E',
    borderRadius: '100%',
    width: '50px',
    height: '50px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },

  historyItem: {
    cursor: 'pointer',
    listStyle: 'none',
    fontSize: '14px',
    marginBottom: '5px',
    whiteSpace: 'nowrap',
  },

  historyDiv: {
    height: 'calc(100vh - 30px)',
    overflowY: 'scroll',
  },
};

const preparedMessages = [
  "Сколько продаж было в марте 2023 года?",
  "Сколько магазинов функционировало более 300 дней в 2023 году?",
  "Покажи в каком магазине был самый большой оборот в 2023 году?",
  "Какие 3 магазина продали больше всего чипсов в марте 2023 года?",

  'Какая выручка была в марте 2023 суммарно по всем магазинам?',
  'Сколько магазинов работало более 300 дней в 2023?',
  'Сравни выручку в 2023 и 2024 годах с детализацией по каждому магазину.',
  'Что продавали в Ривьера в марте 2023?',
  'Сколько бутылок воды Samal продано в марте 2023?',
  'Какой объем продаж в деньгах и штуках был в сентябре 2024 года (с детализаций по каждому магазину отдельно)?',
  'Сколько макарон продано 12 марта 2023?',
  'Выручка от воды Samal в сентябре 2023?',
  'Средняя цена закупки макарон в июне 2023?',
  'Цена продажи воды ASU 1л в сентябре 2023?',
  'Какие у тебя есть данные и за какой период?',
  'Что ты можешь посчитать по продажам?',
]

function truncateText(text, maxLength = 45) {
  return text.length > maxLength
      ? text.slice(0, maxLength) + '...'
      : text;
}

function filterByDateRange(data, range) {
  const now = dayjs();
  const today = now.startOf('day');
  const yesterday = today.subtract(1, 'day');
  const last7 = today.subtract(7, 'day');
  const last30 = today.subtract(30, 'day');

  return data?.filter(item => {
    const itemDate = dayjs(item?.props?.datadate);

    switch (range) {
      case 'today':
        return itemDate.isSame(today, 'day');
      case 'yesterday':
        return itemDate.isSame(yesterday, 'day');
      case 'last7':
        return itemDate.isAfter(last7) &&
            itemDate.isBefore(yesterday, 'day');
      case 'last30':
        return itemDate.isAfter(last30) &&
            itemDate.isBefore(last7, 'day');
      default:
        return true;
    }
  });
}




function ChatV2() {
  // const { apiUrl, promptMessage, preparedMessages } = props;

  const apiUrl = "https://ai-demo.frontier.kz/api/gpt"

  const promptMessage =  "Добрый день! <br>" +
      "Я – AI-ассистент по продажам и закупкам. Помогу узнать информацию связанную с количество продаж и закупок за исторический период 2023 и 2024 года."




  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [threadId, setThreadId] = useState(null);
  const [isTyping, setIsTyping] = useState(false);
  const [typingText, setTypingText] = useState('');
  const [faqModal, setFaqModal] = useState(false);
  const [history, setHistory] = useState(null);
  const [waitHistory, setWaitHistory] = useState(false);
  const [leftBar, setLeftBar] = useState(false);
  const msgContainer = useRef();



  const onOpenFaqModal = () => {
    setFaqModal(true);
  }

  const onCloseFaqModal = () => {
    setFaqModal(false);
  }


  const onCloseLeftBar = () => {
    setLeftBar(false);
  }

  const onOpenLeftBar = () => {
    setLeftBar(true);
  }


  const newChat = () => {
    const promptMessage =  "Добрый день! <br>" +
        "Я – AI-ассистент по продажам и закупкам. Помогу узнать информацию связанную с количество продаж и закупок за исторический период 2023 и 2024 года."

    setLeftBar(false)
    setThreadId(null)
    setMessages([
      {
        text: promptMessage,
        fromUser: false,
      }
    ])
    setInput('')
    setHistory(null)
    setWaitHistory(false)
    getHistoryMessages()

  }

  const logout = logoutEv

  const onChangeHistory = (threadId) => {
    getHistoryMessage(threadId)
  }


  const historyItems = history?.map(item => {
    return <Tooltip
        title={item.title}
        // datadate={dayjs(item.created_at).format('DD.MM.YYYY')}
        datadate={item.created_at}
    >
      <li
          style={styles.historyItem}
          onClick={() => onChangeHistory(item.thread_id)}
      >
        {truncateText(item.title)}
      </li>
    </Tooltip>
  })


  const today = filterByDateRange(historyItems, 'today')



  useEffect(() => {
    // Добавляем стартовое сообщение при загрузке виджета
    const initialMessage = {
      text: promptMessage,
      fromUser: false,
    };
    setMessages([initialMessage]);
  }, []);

  useEffect(() => {
    if (history === null && waitHistory === false) {
      setWaitHistory(true)
      getHistoryMessages()
    }
  }, history);


  function processText(input) {
    // Разбиваем текст на строки
    const lines = input?.split(/(?<=\\.)\\d+\\.\\s/); // Разделяем по номеру с точкой и пробелом
    const result = [];

    lines.forEach((line) => {
      // Убираем `**` и заменяем содержимое внутри `【】` на пустую строку
      const cleanedLine = line
        .replace(/\\*\\*/g, '')
        .replace(/【[^】]*】/g, '')
        .replace(/\*\*(.*?)\*\*/g, '<b>$1</b>')
        .replace(/(\s\d+\.)/g, '<br/>$1')
        .replace(/(\s-\s)/g, '<br/>$1')
        .replaceAll(
          /(\[Шаблон.+\]|\[.+Шаблон\]|\[.+Шаблон.+\]|\[Шаблон\]|\[Документ\]|\[Excel\])(\(https:\/\/.+\))/gim,
          (match, p1, p2) => {
            return `<a href="${p2.replaceAll(
              /[\(|\)]/g,
              ''
            )}" target="_blank">Шаблон ${
              p2.includes('docx')
                ? google_service_dict.DOCX
                : p2.includes('xlsx')
                  ? google_service_dict.Excel
                  : ''
            }</a>`;
          }
        );

      if (cleanedLine.trim()) {
        result.push(cleanedLine.trim());
      }
    });

    // Возвращаем текст с новой строки для каждого пункта
    return result.join('\\n');
  }

  const sendMessage = async (msg) => {
    const text = typeof msg === 'string' ? msg : input;

    if (!text.trim()) return;

    // Отображаем исходящее сообщение
    const newMessages = [...messages, { text, fromUser: true }];
    setMessages(newMessages);
    setInput('');
    setIsTyping(true);
    setTimeout(() => {
      if (msgContainer.current) {
        msgContainer.current.scrollTop = msgContainer.current.scrollHeight;
      }
    }, 0);


    // debugger

    // Отправляем сообщение в API
    try {

      const formData = new FormData();
      formData.append('content', text);
      threadId !== null && formData.append('thread_id', threadId);
      // formData.append('file', fileInput.files[0]);


      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          // 'Content-Type': 'application/json',
          Authorization: `Bearer ${cookies.get('access_token')}`,
        },
        body: formData,
      });
      const data = await response?.json();

      if (data.detail === "Unauthorized") {
        logout()
        setTimeout(function() {
          window.location.reload();
        }, 3000);
      }

      // Сохраняем thread_id при первом ответе
      if (!threadId) {
        setThreadId(data.thread_id);
      }
      // Анимация печати входящего сообщения
      // animateIncomingMessage(data?.result?.replace(/\n/g, "<br>"), newMessages);
      animateIncomingMessage(data, newMessages);
    } catch (error) {
      console.error('Ошибка при запросе API:', error);
      animateIncomingMessage(
          {
            error: true,
            message: null,
            result: 'Ой, что-то пошло не так. <br>' +
                'Повторите, пожалуйста, свой вопрос.'
          },
          newMessages
      );

    } finally {
      setIsTyping(false);
    }
  };

  const getHistoryMessages = async () => {
    // Отправляем сообщение в API
    try {
      const response = await fetch(apiUrl, {
        method: 'Get',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${cookies.get('access_token')}`,
        },
      });
      const data = await response?.json();

      if (data.detail === "Unauthorized") {
        logout()
        setTimeout(function() {
          window.location.reload();
        }, 3000);
      }
      setHistory(data)
    } catch (error) {
      console.error('Ошибка при запросе API:', error);
    }
  };


  const getHistoryMessage = async (threadId) => {
    // Отправляем сообщение в API
    try {
      const response = await fetch(`${apiUrl}/${threadId}`, {
        method: 'Get',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${cookies.get('access_token')}`,
        },
      });
      const data = await response?.json();

      const newData = data.flatMap(item => {
        return [
            {
              text: item.message,
              fromUser: true
            },
            {
              text: typeof item.result === 'string' ? item.result : '',
              tableData: typeof item.result === 'string' ? null : item.result,
              fromUser: false
            }
        ]
      })
      setMessages(newData)
      setLeftBar(false)
      setThreadId(threadId)


      if (data.detail === "Unauthorized") {
        logout()
        setTimeout(function() {
          window.location.reload();
        }, 3000);
      }
      // setHistory(data)
    } catch (error) {
      console.error('Ошибка при запросе API:', error);
    }
  };


  const animateIncomingMessage = (text, newMessages) => {
    const isArray = Array.isArray(text?.result);
    const fullText = typeof text === 'string' ? text : text?.result;

    if (!fullText) return;

    if (text.error === true) {
      setMessages([
        ...newMessages,
        {
          fromUser: false,
          text: text?.result
          // tableData: text.result,
        },
      ]);
      return;
    }

    if (isArray) {
      setMessages([
        ...newMessages,
        {
          text: '',
          fromUser: false,
          tableData: text.result,
        },
      ]);
      return;
    }

    let index = 0;

    setMessages(newMessages);
    setTypingText('');

    const printChar = () => {
      setTypingText(fullText.slice(0, index + 1));
      index++;

      if (msgContainer.current) {
        msgContainer.current.scrollTop = msgContainer.current.scrollHeight;
      }

      if (index < fullText.length) {
        setTimeout(printChar, 10);
      } else {
        setMessages((prev) => [
          ...prev,
          {
            text: processText(fullText),
            fromUser: false,
            tableData: null,
          },
        ]);
        setTypingText('');
      }
    };

    printChar();
  };



  const popoverContent = (
    <div>
      {preparedMessages?.map((item) => {
        return (
          <div
            className={style.preparedMessage_popover_option}
            onClick={() => sendMessage(item)}
          >
            {item}
          </div>
        );
      })}
    </div>
  );

  return (
      <Layout>
        <Sider
            width={400}
            style={{
              position: 'absolute',
              minHeight: '100vh',
              zIndex: 10,
              top: 0,
              left: leftBar ? 0 : '-400px',
              // background: 'rgb(135, 201, 96)',
              background: 'rgb(248, 255, 248)',
              borderRadius: '10px',
              transition: '.4s',
              paddingBottom: '20px'

            }}
        >
          <Button
            icon={<CloseOutlined/>}
            style={{
              fontSize: '25px',
              position: 'absolute',
              right: '10px',
              top: '10px',
              color: "#87c960",
              cursor: 'pointer',
              border: 'none',
              background: 'none'
            }}
            onClick={() => onCloseLeftBar()}
          />
          <h3 style={{marginLeft: '24px'}}>
            История запросов
          </h3>



          <div
            className={style.historyDiv}
          >
            {
                filterByDateRange(historyItems, 'today')?.length > 0 && <>
                  <h4 className={style.historyH4}>Сегодня</h4>
                  <ul className={style.historyUl}>
                    {filterByDateRange(historyItems, 'today')}
                  </ul>
                </>
            }

            {
                filterByDateRange(historyItems, 'yesterday')?.length > 0 && <>
                  <h4 className={style.historyH4}>Вчера</h4>
                  <ul className={style.historyUl}>
                    {filterByDateRange(historyItems, 'yesterday')}
                  </ul>
                </>
            }

            {
                filterByDateRange(historyItems, 'last7')?.length > 0 && <>
                  <h4 className={style.historyH4}>Последние 7 дней</h4>
                  <ul className={style.historyUl}>
                    {filterByDateRange(historyItems, 'last7')}
                  </ul>
                </>
            }


            {
                filterByDateRange(historyItems, 'last30')?.length > 0 && <>
                  <h4 className={style.historyH4}>Последние 30 дней</h4>
                  <ul className={style.historyUl}>
                    {filterByDateRange(historyItems, 'last30')}
                  </ul>
                </>
            }

          </div>







        </Sider>
        <div style={styles.chatContainer}>
            <Header
              style={{
                background: "linear-gradient(118.17deg, rgb(237, 247, 238) 0%, rgb(206, 255, 211) 100%) rgb(249, 249, 249)",
                padding: '0 20px',
                borderBottom: '1px solid lightgray'
              }}
            >
              <Row gutter={16}>
                <Col>
                    <Tooltip title={'Открыть мастер-файл проекта: бюджет, график работ, описание данных и ключевые документы.'}>
                      <Button
                          type="primary"
                          href={'https://docs.google.com/spreadsheets/d/1pDts_ZB890aT77YUnBO1rxdgtTXeK6Wl/edit?gid=1526271682#gid=1526271682'}
                          target={'_blank'}
                          // icon={<ContainerOutlined/>}
                          icon={<FileDoneOutlined />}

                          shape="round"
                          style={{
                            background: 'rgb(48, 169, 62)',
                            fontSize: '20px'
                          }}
                      />
                    </Tooltip>
                </Col>
                <Col>
                  <Tooltip title={'Возможности чата, терминология, использование данных'}>
                    <Button
                        type="primary"
                        onClick={() => onOpenFaqModal()}
                        icon={<QuestionCircleOutlined/>}
                        shape="round"
                        style={{
                          background: 'rgb(48, 169, 62)',
                          fontSize: '20px'
                        }}
                    />
                  </Tooltip>
                </Col>

                <Col>
                  <Tooltip title={'История запросов'}>
                    <Button
                        type="primary"
                        onClick={() => onOpenLeftBar()}
                        icon={<HistoryOutlined />}
                        shape="round"
                        style={{
                          background: 'rgb(48, 169, 62)',
                          fontSize: '20px'
                        }}
                    />
                  </Tooltip>
                </Col>

                <Col>
                  <Tooltip title={'Новый чат'}>
                    <Button
                        type="primary"
                        onClick={() => newChat()}
                        icon={<FileAddOutlined />}
                        shape="round"
                        style={{
                          background: 'rgb(48, 169, 62)',
                          fontSize: '20px'
                        }}
                    />
                  </Tooltip>
                </Col>





              </Row>

            </Header>
          <FaqModal
            open={faqModal}
            close={() => onCloseFaqModal()}
          />


          <div style={styles.messagesContainer} ref={msgContainer}>

            {messages.map((msg, i) => (
               msg.fromUser ? <div
                       key={i}
                       style={{
                         ...styles.message,
                         ...(msg.fromUser ? styles.userMessage : styles.apiMessage),
                         width: msg?.tableData?.length > 0 ? '80%' : 'auto',
                       }}
                   >

                     {
                       msg?.tableData?.length > 0 ?
                           <TableChat data={msg?.tableData} />
                           : <p
                               style={styles.messageText}
                               dangerouslySetInnerHTML={{ __html: msg.text }}
                           />
                     }

                   </div>
                   :


                   <div style={styles.apiMessage_wrapper}>
                     <div style={styles.api_avatar}>
                       <img src={ab_ai_icon} />
                     </div>

                     <div
                         key={i}
                         style={{
                           ...styles.message,
                           ...(msg.fromUser ? styles.userMessage : styles.apiMessage),
                           width: msg?.tableData?.length > 0 ? '80%' : 'auto',
                         }}
                     >
                       {
                         msg.fromUser ? <div style={styles.api_avatar}>
                           <img src={ab_ai_icon} />
                         </div> : ''
                       }

                       {
                         msg?.tableData?.length > 0 ?
                             <TableChat data={msg?.tableData} />
                             : <p
                                 style={{
                                   ...styles.messageText,
                                 }}
                                 dangerouslySetInnerHTML={{ __html: msg.text }} // Используем dangerouslySetInnerHTML для отображения HTML
                             />
                       }
                     </div>
                   </div>
            ))}


            {isTyping && (
                <div style={styles.apiMessage_wrapper}>
                  <div style={styles.api_avatar}>
                    <img src={ab_ai_icon} />
                  </div>
                  <div
                      style={{
                        background: '#fff',
                        padding: '0.5rem 0.75rem',
                        borderRadius: '12px',
                        marginBottom: '0.5rem',
                        maxWidth: '75%',
                        color: '#000',
                        whiteSpace: 'pre-wrap',
                        fontSize: '16px',
                        lineHeight: '28px',
                        fontFamily: 'Inter',
                      }}
                  >
                    ...
                  </div>
                </div>
            )}

            {typingText && (
                <div style={styles.apiMessage_wrapper}>
                  <div style={styles.api_avatar}>
                    <img src={ab_ai_icon} />
                  </div>
                  <div
                      style={{
                        background: '#fff',
                        padding: '0.5rem 0.75rem',
                        borderRadius: '12px',
                        marginBottom: '0.5rem',
                        maxWidth: '75%',
                        color: '#000',
                        whiteSpace: 'pre-wrap',
                        fontSize: '16px',
                        lineHeight: '28px',
                        fontFamily: 'Inter',
                      }}
                  >
                    {typingText}
                    <span className="blinking-cursor">|</span>
                  </div>
                </div>
            )}


          </div>
          <div style={styles.inputContainer}>
            {preparedMessages?.length > 0 ? (
              messages.length === 1 ? (
                <div style={styles.preparedMessages_wrapper}>
                  <div
                    style={{
                      display: 'flex',
                      // columnGap: 0,
                      width:
                        preparedMessages?.length * 179 +
                        (preparedMessages?.length - 2) * 20,
                    }}
                  >
                    {preparedMessages?.map((item, index) => {
                      return (
                        <div
                          key={index}
                          style={styles.preparedMessage}
                          onClick={() => sendMessage(item)}
                        >
                          <div style={styles.preparedMessage_badge}>
                            <img src={ai_prep_message} />
                          </div>
                          {item}
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : (
                <Popover
                  content={popoverContent}
                  trigger="click"
                  overlayInnerStyle={styles.preparedMessage_popover}
                >
                  <div style={styles.preparedMessage_popover_button}>
                    <img src={ai_prep_bigger} />
                  </div>
                </Popover>
              )
            ) : (
              ''
            )}
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Задайте вопрос AI-ассистенту"
              style={styles.input}
              onKeyPress={(e) => e.key === 'Enter' && sendMessage()}
            />
            <button onClick={sendMessage} style={styles.sendButton}>
              Отправить
            </button>
            {/*<button onClick={getHistoryMessage} style={styles.sendButton}>*/}
            {/*  Получить HISTORY*/}
            {/*</button>*/}
          </div>
        </div>
      </Layout>
  );
}





export default ChatV2;
